import React, { useState, useEffect } from 'react';
import './Modal.css';

const TaskModal = ({ show, onClose, onSave, task, existingTasks = [] }) => {
  const [name, setName] = useState('');
  const [assignee, setAssignee] = useState('');
  const [status, setStatus] = useState('未开始');
  const [hours, setHours] = useState(0);
  const [parentId, setParentId] = useState(null);

  // Filter for potential parent tasks (only top-level tasks)
  const potentialParents = existingTasks.filter(t => !t.parentId);

  useEffect(() => {
    // Check for task.id to differentiate between editing an existing task and creating a new one.
    if (task && task.id) { // Editing an existing task
      setName(task.name || '');
      setAssignee(task.assignee || '');
      setStatus(task.status || '未开始');
      setHours(task.hours || 0);
      setParentId(task.parentId || null);
    } else { // Adding a new task
      setName('');
      setAssignee('');
      setStatus('未开始');
      setHours(0);
      setParentId(task?.parentId || null); // Keep parentId if creating a sub-task
    }
  }, [task, show]);

  if (!show) {
    return null;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({ name, assignee, status, hours: Number(hours), parentId });
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>{task ? '编辑任务' : '添加新任务'}</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>任务名称</label>
            <input type="text" value={name} onChange={e => setName(e.target.value)} required />
          </div>
          <div className="form-group">
            <label>负责人</label>
            <input type="text" value={assignee} onChange={e => setAssignee(e.target.value)} required />
          </div>
           <div className="form-group">
            <label>估算工时(小时)</label>
            <input type="number" value={hours} onChange={e => setHours(e.target.value)} required min="0" />
          </div>
          <div className="form-group">
            <label>父任务 (可选)</label>
            <select 
                value={parentId || ''} 
                onChange={e => setParentId(e.target.value || null)}
                // Cannot be its own parent, and sub-tasks cannot be parents
                disabled={!!task?.id && (potentialParents.every(p => p.id !== task.id) || !!task.parentId)}
            >
              <option value="">无 (顶级任务)</option>
              {potentialParents
                .filter(p => p.id !== task?.id) // A task cannot be its own parent
                .map(p => (
                  <option key={p.id} value={p.id}>{p.name}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>状态</label>
            <select value={status} onChange={e => setStatus(e.target.value)}>
              <option value="未开始">未开始</option>
              <option value="进行中">进行中</option>
              <option value="已完成">已完成</option>
            </select>
          </div>
          <div className="modal-actions">
            <button type="submit" className="btn">保存</button>
            <button type="button" className="btn btn-secondary" onClick={onClose}>取消</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TaskModal; 